










































































































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getIndexFromList
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import CreateVarClassification from './CreateVarClassification.vue';
import {
    MsgBox,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import Input from '../../core/components/Input.vue';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        PlusEyeButtons,
        CreateVarClassification,
        Breadcrums,
        CloseConfirmationModal,
        Input
    }
})
export default class CreateUnityInVarClassification extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() visibleFrameFromList: any;
    @Prop() currentAction: string;
    @Prop() patchData: any;
    @Prop() classificationOptions: any;
    @Prop() editingEcu: boolean;
    @Prop() editing: boolean;
    @Prop() editingFrame: boolean;
    @Prop() editingParam: boolean;
    @Prop() unityOptions: any;
    @Prop() editingVarClassification: any;
    @Prop() editingVarDefinition: any;

    visibleCloseConfirmationModal: boolean = false;
    visibleModal: boolean = false;
    description: string = '';
    privateDescription: string = '';
    pendingRequest: boolean = false;
    submitButtonText: string = '';
    modalTitle: string = '';

    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;
    varClassificationSelected: boolean | null = null;
    classificationRV: boolean = false;

    //Breadcrums
    breadcrumsItems: any = [];
    varClassificationOptions: any = [];

    //modal create var classification
    visibleModalCreateVarClass: boolean = false;
    editingVarClass: boolean = false;
    patchDataVarClass: any = {};

    //methods
    mounted() {
        this.handleListenKey(true);
        this.getClassificationOptions();

        this.visibleModal = this.visible;

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_VISIBLE, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_FRAMES_DIALOG_VISIBLE, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_PARAMETER_DIALOOG_CLOSE_CHILDREN_COMPONENTS, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_VAR_DEFINITION_DIALOOG_CLOSE_CHILDREN_COMPONENTS, () => {
            this.closeModal();
        });

        if (this.editing) {
            this.submitButtonText = 'Modificar ' + this.currentAction;
            this.modalTitle = 'Modificar ' + this.currentAction + ' <b> - ' + this.patchData['description'] + '</b>';
            this.loadPatchData();
        } else {
            this.submitButtonText = 'Crear ' + this.currentAction;
            this.modalTitle = 'Crear ' + this.currentAction;
        }
    }

    updateDescription(value){
        this.description = value;
    }
    updatePrivateDescription(value){
        this.privateDescription = value;
    }

    visibilityModalCreateClass(value) {
        this.visibleModalCreateVarClass = value;
        this.enableScrollLoadingDialog();
    }

    loadPatchData() {
        this.description = this.patchData['description'];
    }

    updateClassificationSelected(option) {
        this.varClassificationSelected = option;
    }

    updateClassificationRV(value) {
        this.classificationRV = value;
    }

    getClassificationOptions() {
        let self = this;
        NormsServices.getVariableClassificationList()
            .then(response => {
                self.varClassificationOptions = response;
                self.varClassificationOptions.sort(sortObjectByPropertyName('description'));
            })
            .catch(error => {});
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.handleListenKey(false);
        this.visibilityCloseConfirmationModal(false);
    }

    showCloseConfirmationModal() {
        this.visibilityCloseConfirmationModal(true);
    }

    visibilityCloseConfirmationModal(value) {
        this.visibleCloseConfirmationModal = value;
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    get getBreadcrumsItems() {
        let breadcrumsOptions = [
            {
                text: this.visibleFrameFromList ? 'Listado de Frames' : 'Listado de ECUs',
                disabled: false,
                href: '',
                active: false,
                action: 'goToEcuList'
            },
            {
                text: !this.editingEcu ? 'Crear Ecu' : 'Modificar ECU',
                disabled: false,
                href: '',
                active: false,
                action: 'goToEcuDialog'
            },
            {
                text: this.editingFrame ? 'Modificar frame' : 'Crear frame',
                disabled: false,
                href: '',
                active: false,
                action: 'goToFrameDialog'
            },
            {
                text: this.editingParam ? 'Modificar Parámetro' : 'Agregar parámetro',
                disabled: false,
                href: '',
                active: false,
                action: 'goToParameterDialog'
            },
            {
                text: this.editingVarDefinition ? 'Modificar Variable Definition' : 'Crear Variable Definition',
                disabled: false,
                href: '',
                active: false,
                action: 'goToVarDefinitionDialog'
            },
            {
                text: this.editingVarClassification
                    ? 'Modificar Variable Classification'
                    : 'Crear Variable Classification',
                disabled: false,
                href: '',
                active: false,
                action: 'back'
            },
            {
                text: this.editing ? 'Modificar ' + this.currentAction : ' Crear ' + this.currentAction,
                disabled: false,
                href: '',
                active: true,
                action: null
            }
        ];

        if (this.visibleFrameFromList) {
            breadcrumsOptions.splice(1, 1);
        }

        return breadcrumsOptions;
    }

    triggerSubmit() {
        let self = this;
        this.pendingRequest = true;
        let configuration = this.getData();
        self.scrollToTopOfModal();
        this.clearScrollLoadingDialog();
        if (!this.editing) {
            self.pendingLoadingDialog('Generando ' + this.currentAction + '...')
            // console.log("post slot", configuration);
            // if(this.currentAction === 'Tipo Variable'){
            //     NormsServices.postCreateTipoVariable(configuration)
            //         .then((response) => {
            //             self.successPost = true;
            //             self.msgLoadingDialog = response['message'];
            //             setTimeout(() => {
            //             self.pendingRequest = false;
            //             self.closeModal();
            //                 self.$emit('add-new-tipo-variable', response['tipovariable']);
            //                 self.successPost = null;
            //                 self.msgLoadingDialog = '';
            //             }, 1000);
            //         })
            //         .catch((error) => {
            //             // console.log("error protocolo", error);
            //             self.handleCatchResponse(error);
            //         });
            if (this.currentAction === 'Variable Definition') {
                NormsServices.postCreateVarDefinition(configuration)
                    .then(response => {
                        self.successPost = true;
                        self.handleSuccessAction(response);
                        self.pendingRequest = false;
                        self.closeModal();
                        self.$emit('add-new-var-def', response['variable_definition']);
                    })
                    .catch(error => {
                        // console.log("error protocolo", error);
                        self.handleErrorAction(error, 'Ocurrio un error al crear la variable definition');
                    });
            } else if (this.currentAction === 'Unidad') {
                NormsServices.postCreateUnidad(configuration)
                    .then(response => {
                        self.successPost = true;
                        self.handleSuccessAction(response);
                        self.pendingRequest = false;
                        self.closeModal();
                        self.$emit('add-new-unity', response['unidad']);
                    })
                    .catch(error => {
                        // console.log("error protocolo", error);
                        self.handleErrorAction(error, 'Ocurrio un error al crear la unidad');
                    });
            }
        } else {
            self.pendingLoadingDialog('Modificando ' + this.currentAction + '...')
            let id = Number(this.patchData['id']);
            // if(this.currentAction === 'Tipo Variable'){
            //     NormsServices.patchTipoVariable(configuration, id)
            //         .then((response) => {
            //             self.successPost = true;
            //             self.msgLoadingDialog = response['data']['message'];
            //             setTimeout(() => {
            //             self.pendingRequest = false;
            //             self.closeModal();
            //                 self.$emit('update-tipo-variable',  response['data']['tipovariable']);
            //                 self.successPost = null;
            //                 self.msgLoadingDialog = '';
            //             }, 1000);
            //         })
            //         .catch((error) => {
            //             // console.log("error protocolo", error);
            //             self.handleCatchResponse(error);
            //         });
            if (this.currentAction === 'Variable Definition') {
                NormsServices.patchVarDefinition(configuration, id)
                    .then(response => {
                        self.successPost = true;
                        self.handleSuccessAction(response['data']);
                        self.pendingRequest = false;
                        self.closeModal();
                        self.$emit('update-var-def', response['data']['variable_definition']);
                    })
                    .catch(error => {
                        self.handleErrorAction(error, 'Ocurrio un error al modificar la variable definition');
                    });
            } else if (this.currentAction === 'Unidad') {
                NormsServices.patchUnidad(configuration, id)
                    .then(response => {
                        self.successPost = true;
                        self.handleSuccessAction(response['data']);
                        self.pendingRequest = false;
                        self.closeModal();
                        self.$emit('update-new-unity', response['data']['unidad']);
                    })
                    .catch(error => {
                        // console.log("error protocolo", error);
                        self.handleErrorAction(error, 'Ocurrio un error al modificar la unidad');
                    });
            }
            // NormsServices.patchSlot(configuration, this.patchData['id'])
            //         .then((response) => {
            //             self.successPost = true;
            //             self.msgLoadingDialog = response['data']['message'];
            //             setTimeout(() => {
            //                 self.pendingRequest = false;
            //                 self.closeModal();
            //                     self.$emit('updated-slot', response['data']['slot']);
            //                     self.successPost = null;
            //                     self.msgLoadingDialog = '';
            //                 }, 1000);
            //             })
            //         .catch((error) => {
            //             self.handleCatchResponse(error);
            //         });
        }
    }

    clearScrollLoadingDialog() {
        $('html').css('overflow-y', 'hidden');
        $('.dialog-slot').css('overflow-y', 'hidden');
    }

    scrollToTopOfModal() {
        $('.dialog-slot').scrollTop(0);
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    createVarClassification() {
        this.editingVarClass = false;
        this.visibilityModalCreateClass(true);
    }

    modifyVarClassification() {
        let self = this;
        this.editingVarClass = true;
        let classificationId = this.varClassificationSelected !== null ? this.varClassificationSelected['id'] : null;
        if (classificationId !== null) {
            NormsServices.getVariableClassificationById(classificationId)
                .then(response => {
                    self.patchDataVarClass = response;
                    self.visibilityModalCreateClass(true);
                })
                .catch(error => {
                    // self.handleCatchResponse(error);
                });
        }
    }

    getData() {
        let data = {
            description: this.description.trim()
        };
        if (this.currentAction === 'Variable Definition') {
            const value =
                this.privateDescription === '' || this.privateDescription === ' ' ? null : this.privateDescription.trim();
            const classificationId =
                this.varClassificationSelected !== null ? this.varClassificationSelected['id'] : null;
            this.$set(data, 'private_description', value);
            this.$set(data, 'classification', classificationId);
        }
        return data;
    }

    get checkIfFormIsValid() {
        if (this.description !== '') {
            return true;
        } else {
            return false;
        }
    }

    enableScrollLoadingDialog() {
        $('.dialog-slot').css('overflow-y', 'auto');
        $('html').css('overflow-y', 'auto');
    }

    closeModalLoadingDialog() {
        this.pendingRequest = false;
        this.successPost = null;
        this.msgLoadingDialog = '';
        this.enableScrollLoadingDialog();
    }

    addNewVarClasification(newVarClass) {
        let newVarDefClass = {
            id: newVarClass['id'],
            description: newVarClass['description']
        };
        this.varClassificationOptions.push(newVarDefClass);
        this.updateClassificationSelected(newVarDefClass);
        this.varClassificationOptions.sort(sortObjectByPropertyName('description'));
        this.$_successPatchRecipients('Variable Classification agregada');
    }

    updateVarClasification(updatedVarClass) {
        let indexVarDefClass = getIndexFromList(this.varClassificationOptions, 'id', updatedVarClass['id']);
        this.$set(this.varClassificationOptions[indexVarDefClass], 'id', updatedVarClass['id']);
        this.$set(this.varClassificationOptions[indexVarDefClass], 'description', updatedVarClass['description']);
        this.varClassificationOptions.sort(sortObjectByPropertyName('description'));
        this.$_successPatchRecipients('Variable Classification modificada');
    }
}
